<template>
  <v-container fluid class="pa-6">
    <v-card class="modern-card" elevation="0">
      <v-card-title class="px-6 py-4 d-flex align-center">
        <v-icon left color="accent" class="mr-3">fas fa-layer-group</v-icon>
        <span class="text-h6 font-weight-bold primary--text">Mapeo Familias → Categorías Relbase</span>
        <v-spacer />
        <v-chip
          small outlined
          :color="mappedCount > 0 ? 'accent' : 'grey'"
          class="font-weight-medium"
        >
          {{ mappedCount }} de {{ families.length }} familias mapeadas
        </v-chip>
      </v-card-title>

      <v-divider />

      <v-data-table
        :headers="headers"
        :items="families"
        :loading="loading"
        class="modern-table"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageOptions: [10, 20, 50],
        }"
      >
        <template v-slot:top>
          <div class="px-6 py-4 border-bottom d-flex align-center bg-white">
            <v-text-field
              v-model="search"
              placeholder="Buscar familia..."
              prepend-inner-icon="fas fa-search"
              outlined dense hide-details="auto"
              clearable
              class="modern-search-field flex-grow-1"
              style="max-width: 400px;"
            />
          </div>
        </template>

        <template v-slot:item.name="{ item }">
          <div class="d-flex align-center">
            <v-avatar size="32" color="accent" class="mr-3">
              <span class="white--text text-caption font-weight-bold">
                {{ getInitials(item) }}
              </span>
            </v-avatar>
            <div>
              <div class="font-weight-medium primary--text">{{ item.name }}</div>
              <div class="text-caption grey--text">ID: {{ item.id }}</div>
            </div>
          </div>
        </template>

        <template v-slot:item.relbase_category_id="{ item }">
          <v-autocomplete
            v-model="item.relbase_category_id"
            :items="relbaseCategories"
            item-text="name"
            item-value="relbase_id"
            placeholder="Seleccionar categoría Relbase"
            outlined dense hide-details="auto"
            clearable
            :loading="savingId === item.id"
            @change="saveMapping(item)"
            class="my-1"
            style="max-width: 320px;"
          >
            <template v-slot:item="{ item: category }">
              <v-list-item-content>
                <v-list-item-title>{{ category.name }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </template>

        <template v-slot:item.status="{ item }">
          <v-chip
            x-small
            :color="item.relbase_category_id ? 'accent' : 'grey lighten-2'"
            :text-color="item.relbase_category_id ? 'white' : 'grey darken-1'"
            class="font-weight-medium"
          >
            {{ item.relbase_category_id ? 'Mapeado' : 'Sin mapear' }}
          </v-chip>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { fetchFamily } from '@/api/products'
import { fetchRelbaseCategories } from '@/api/relbase'
import axios from 'axios'
import notifications from '@/utils/notifications'

export default {
  name: 'FamilyMapping',
  data() {
    return {
      loading: false,
      savingId: null,
      search: '',
      families: [],
      relbaseCategories: [],
    }
  },
  computed: {
    headers() {
      return [
        { text: 'Familia', value: 'name', sortable: true },
        { text: 'Categoría Relbase', value: 'relbase_category_id', sortable: false },
        { text: 'Estado', value: 'status', align: 'center', sortable: false, width: '120' },
      ]
    },
    mappedCount() {
      return this.families.filter(f => f.relbase_category_id).length
    },
  },
  async mounted() {
    await this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const [families, relbaseCategories] = await Promise.all([
          fetchFamily(),
          fetchRelbaseCategories(),
        ])
        this.families = families || []
        this.relbaseCategories = relbaseCategories || []
      } catch (e) {
        notifications.showError('Error al cargar datos de familias y categorías')
      } finally {
        this.loading = false
      }
    },
    async saveMapping(family) {
      this.savingId = family.id
      try {
        await axios.patch(`product/family/${family.id}`, {
          relbase_category_id: family.relbase_category_id || null,
        })
        notifications.showSuccess('Mapeo actualizado correctamente')
      } catch (e) {
        notifications.showError('Error al guardar el mapeo')
      } finally {
        this.savingId = null
      }
    },
    getInitials(family) {
      return (family.name || '?').charAt(0).toUpperCase()
    },
  },
}
</script>
